import { Dialog } from "components/dialog/Dialog";
import { DialogFooter } from "components/dialog/DialogFooter/DialogFooter";
import { DialogHeader } from "components/dialog/DialogHeader/DialogHeader";
import { DialogBody } from "components/dialog/DialogMain/DialogBody/DialogBody";
import { DialogMain } from "components/dialog/DialogMain/DialogMain";
import { useDialogContext } from "components/dialog/controller/DialogProvider";

export const SwitchPagesDialog = () => {
  const { dialogProps } = useDialogContext();
  return (
    <Dialog size="small" state="info">
      <DialogHeader>Switch Pages</DialogHeader>
      <DialogMain>
        <DialogBody>
          Are you sure you want to switch pages?
          <br />
          All unsaved changes will be lost.
        </DialogBody>
      </DialogMain>
      <DialogFooter
        button={{
          label: "Switch",
          onClick: dialogProps.buttonClick,
        }}
      />
    </Dialog>
  );
};
